import React from 'react';
import { NavLink } from 'react-router-dom';
import SideNavBar from './SideNavBar';
import { useEffect } from 'react';
import { useState } from 'react';
import { useRef } from 'react';

const WelfareTracking = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const sidebarRef = useRef();

  const [contributions, setContributions] = useState([
    {
      date: '25 April 2025',
      totaltithes: '₦1000',
      amount: '₦15000',
      staus: 'Active',
      member: 'Oluwanifemi Babatunde',
    },
    {
      date: '17 April 2025',
      totaltithes: '₦1000',
      amount: '₦1500',
      staus: 'Active',
      member: 'Oluwanifemi Babatunde',
    },
    {
      date: '1 April 2025',
      totaltithes: '₦1000',
      amount: '₦5000',
      staus: 'Active',
      member: 'Oluwanifemi Babatunde',
    },
    {
      date: '5 July 2025',
      totaltithes: '₦1000',
      amount: '₦10000',
      staus: 'Active',
      member: '',
    },
  ]);

  const handleDelete = index => {
    const updated = contributions.filter((_, i) => i !== index);
    setContributions(updated);
  };

  // Close sidebar when clicking outside (mobile)
  useEffect(() => {
    if (!sidebarOpen) return;
    function handleClick(e) {
      if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
        setSidebarOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [sidebarOpen]);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }, [darkMode]);

  return (
    <div className={darkMode ? 'dark bg-gray-900 min-h-screen' : 'bg-white min-h-screen'}>
      {/* Dark mode toggle */}
      <button
        className={`fixed top-4 right-4 z-50 border-2 border-green-700 rounded-full p-2 shadow-lg transition hover:bg-green-700 hover:text-white
          ${darkMode ? 'bg-gray-800 text-yellow-400' : 'bg-white text-green-800'}`}
        onClick={() => setDarkMode(!darkMode)}
        aria-label="Toggle dark mode"
      >
        {darkMode ? (
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 3v1m0 16v1m8.66-13.66l-.71.71M4.05 19.95l-.71.71M21 12h-1M4 12H3m16.66 4.95l-.71-.71M4.05 4.05l-.71-.71M16 12a4 4 0 11-8 0 4 4 0 018 0z"
            />
          </svg>
        ) : (
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 12.79A9 9 0 1111.21 3a7 7 0 109.79 9.79z"
            />
          </svg>
        )}
      </button>

      {/* Hamburger for mobile */}
      <button
        className="md:hidden fixed top-4 left-4 z-50 p-2 rounded-md bg-white text-black shadow-lg transition-colors duration-300 hover:bg-green-700 hover:text-white"
        onClick={() => setSidebarOpen(true)}
        aria-label="Open sidebar"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      <div className="flex">
        {/* Sidebar - only sidebar is scrollable */}
        {/* Desktop sidebar */}
        <div
          className={`w-60 h-screen overflow-y-auto bg-gradient-to-r ${
            darkMode ? 'from-gray-900 to-gray-800' : 'from-green-800 to-yellow-200'
          } p-3 font-bold custom-scrollbar hidden md:block`}
        >
          <SideNavBar darkMode={darkMode} />
        </div>

        {/* Mobile sidebar overlay */}
        {sidebarOpen && <div className="fixed inset-0 z-40  bg-black bg-opacity-40 md:hidden" />}
        <div
          ref={sidebarRef}
          className={`fixed top-0 left-0 z-50 w-64 h-full bg-gradient-to-r ${
            darkMode ? 'from-gray-900 to-gray-800' : 'from-green-800 to-yellow-200'
          } p-3 font-bold custom-scrollbar transform transition-transform duration-300 md:hidden
            ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}
          style={{ maxWidth: '16rem', overflowY: 'auto' }} // <-- Make mobile sidebar scrollable
        >
          <div className="flex justify-between items-center mb-4">
            <span className="font-bold text-lg text-white">Menu</span>
            <button
              className="p-2 rounded-md bg-gray-200 dark:bg-gray-100"
              onClick={() => setSidebarOpen(false)}
              aria-label="Close sidebar"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <SideNavBar darkMode={darkMode} />
        </div>
        <div className=" shadow-2xl items-center md:ml-10  w-full overflow-y-auto mt-20">
          <div
            className={`font-bold flex justify-between  text-2xl ${
              darkMode
                ? ' bg-gray-800 w-96 mx-auto md:w-11/12 md:mx-0 text-center md:text-left p-4 rounded-md'
                : ' bg-green-900 w-96 mx-auto md:mx-0 md:w-11/12 text-center md:text-left p-4 rounded-md'
            }`}
          >
            {' '}
            <div>
              <h2 className={`font-bold text-2xl ${darkMode ? 'text-green-200' : 'text-white'}`}>
                Welfare Tracking
              </h2>
              <p
                className={`font-semibold mt-3 text-sm ${
                  darkMode ? 'text-green-200' : 'text-white'
                }`}
              >
                Track and manage member welfare payments
              </p>
              <div className="md:flex md:gap-3 mt-7 md:flex-row md:items-start items-start   flex flex-col mx-auto gap-3 ">
                <span
                  className={`p-2 text-center text-sm rounded-md hover:bg-green-900 hover:text-white hover:duration-700 
                ${
                  darkMode
                    ? 'bg-gray-600 border-green-700 text-green-200'
                    : 'bg-gray-200 border-green-700 text-green-900'
                }`}
                >
                  April 2025
                </span>
                <span
                  className={` p-2 ] text-center text-sm rounded-md   hover:bg-green-900 hover:text-white hover:duration-700 
                ${
                  darkMode
                    ? 'bg-gray-600 border-green-700 text-green-200'
                    : 'bg-gray-200 border-green-700 text-green-900'
                }`}
                >
                  Welfare Payment: ₦15000
                </span>
                <span
                  className={`p-2  text-center  text-sm rounded-md hover:bg-green-900 hover:text-white hover:duration-700 
                ${
                  darkMode
                    ? 'bg-gray-600 border-green-700 text-green-200'
                    : 'bg-gray-200 border-green-700 text-green-900'
                }`}
                >
                  Members Participation: 0.18%
                </span>
              </div>
            </div>
            <div className="items-end">
              <NavLink>
                <h2 className="text-green-900 w-20 bg-white p-2 rounded-md text-center text-xs md:text-lg md:w-auto md:mt-12 mt-20 md:my-auto">
                  Add Welfare Payment
                </h2>
              </NavLink>
              <NavLink to="/finance">
                <h2
                  className={`p-2 mt-3  text-center  text-sm rounded-md hover:bg-green-900 hover:text-white hover:duration-700 
                ${
                  darkMode
                    ? 'bg-gray-600 border-green-700 text-green-200'
                    : 'bg-gray-200 border-green-700 text-green-900'
                }`}
                >
                  Back To Finance
                </h2>
              </NavLink>
            </div>
          </div>
          <div
            className={`shadow-2xl p-4 flex-col md:w-11/12 space-y-5 md:space-y-0 md:flex md:gap-3 md:flex-row mt-10 rounded-md ${
              darkMode
                ? 'bg-gray-800  border-green-700 text-green-200'
                : 'bg-white border-green-700 text-gray-700'
            }`}
          >
            <div
              className={` p-4 w-5/6 ml-6 md:w-2/6 rounded-md shadow-lg  ${
                darkMode
                  ? 'bg-gray-700  border-green-700 text-green-200'
                  : 'bg-white border-green-700 text-gray-700'
              }`}
            >
              <h2
                className={` font-semibold text-xs  ${
                  darkMode
                    ? 'bg-gray-700  border-green-700 text-green-200'
                    : 'bg-white border-green-700 text-gray-700'
                }`}
              >
                Total Welfare Collected
              </h2>
              <h1 className=" text-2xl font-bold">₦15000</h1>
            </div>

            <div
              className={` p-4 w-5/6 ml-6 md:w-2/6 rounded-md shadow-lg  ${
                darkMode
                  ? 'bg-gray-700  border-green-700 text-green-200'
                  : 'bg-white border-green-700 text-gray-700'
              }`}
            >
              <h2 className=" font-semibold text-xs">Members Paying Welfare</h2>
              <h1 className=" text-2xl font-bold">{contributions.length}</h1>
            </div>
            <div
              className={` p-4 w-5/6 ml-6 md:w-2/6 rounded-md shadow-lg  ${
                darkMode
                  ? 'bg-gray-700  border-green-700 text-green-200'
                  : 'bg-white border-green-700 text-gray-700'
              }`}
            >
              <h2 className=" font-semibold text-xs">Average Welfareza Amount</h2>
              <h1 className=" text-2xl font-bold">₦5000</h1>
            </div>
          </div>
          <div className="flex-1 overflow-x-auto overflow-y-auto p-4">
            <table className="w-11/12 md:w-11/12 text-gray-700 font-bold text-sm text-left border-collapse min-w-[600px]">
              <thead>
                <tr className="bg-gray-200">
                  <th className="p-2 border-b">Member</th>
                  <th className="p-2 border-b">Total Welfare</th>
                  <th className="p-2 border-b">Last Time date</th>
                  <th className="p-2 border-b">Status</th>

                  <th className="p-2 border-b">Actions</th>
                </tr>
              </thead>
              <tbody>
                {contributions.map((contribution, index) => (
                  <tr key={index} className="hover:bg-gray-100 bg-white hover:duration-700">
                    <td className="p-2 border-b">{contribution.member}</td>
                    <td className="p-2 border-b">{contribution.totaltithes}</td>
                    <td className="p-2 border-b">{contribution.date}</td>
                    <td className="p-2 border-b text-blue-500">
                      <NavLink to="/newmember" className="hover:underline">
                        {contribution.staus}
                      </NavLink>
                    </td>

                    <td className="p-2 border-b">
                      <button
                        onClick={() => handleDelete(index)}
                        className="hover:scale-110 transition-transform"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0,0,256,256"
                          fill="#FA5252"
                        >
                          <g transform="scale(10.66667,10.66667)">
                            <path d="M9.07617,2l-0.5,3h-0.57617h-4.05664l-0.00781,-0.05664l-0.46484,0.05664h-0.9707h-0.5v1h0.5h0.55664l1.94336,16h14l1.94336,-16h0.55664h0.5v-1h-0.5h-0.9707l-0.46484,-0.05664l-0.00781,0.05664h-4.02148h-0.03516h-0.57617l-0.5,-3zM9.92383,3h4.15234l0.33398,2h-4.82031zM4.06445,6h3.90039h1.45898h5.15234h1.42383h3.93555l-1.82227,15h-12.22656zM6.93359,8.94141l-0.99219,0.125l0.0625,0.49609l1,8l0.0625,0.49609l0.99219,-0.125l-0.0625,-0.49609l-1,-8zM17.06641,8.94141l-0.0625,0.49609l-1,8l-0.0625,0.49609l0.99219,0.125l0.0625,-0.49609l1,-8l0.0625,-0.49609zM10,9v0.5v8v0.5h1v-0.5v-8v-0.5zM13,9v0.5v8v0.5h1v-0.5v-8v-0.5z" />
                          </g>
                        </svg>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="bg-gray-200">
                  <td colSpan="6" className="p-2 text-center">
                    Total Records: {contributions.length}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelfareTracking;
